import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'entrega',
    [ORDER_METHODS.PICKUP]: 'takeaway',
    [ORDER_METHODS.ROOM_SERVICE]: 'no local',
  },
  feedback: {
    payment_method_disabled: 'Não aceitamos pagamentos via {{paymentMethod}} para pedidos de {{orderMethod}}',
    cash_disabled: 'Não aceitamos pagamentos em dinheiro para pedidos de {{orderMethod}}',
  },
};
